import { NEW_HOME, RENTAL_PROPERTY, RENT_BUY, SELL_POCKET } from '../../../../constants/gems'
import gems from '../../../shared/PurchasingPower/gems'

import NewHome from './NewHome'
import RentalProperty from './RentalProperty'
import RentBuy from './RentBuy'
import SellPocket from './SellPocket'

const props = {
  [NEW_HOME]: NewHome,
  [RENTAL_PROPERTY]: RentalProperty,
  [RENT_BUY]: RentBuy,
  [SELL_POCKET]: SellPocket
}

export default gems.map(({ key, Gem }) => ({
  ...props[key],
  key,
  Gem: props[key].GemContainer(Gem)
}))
